import { trans } from "@mongez/localization";
import { ShopProduct } from "core/catalog";
import { useEffect } from "react";
import { useInView } from "react-intersection-observer";
import { SwiperSlide } from "swiper/react";
import { ProductsSection, ProductsSlider } from "~/modules/home/components";
import { ProductCard } from "~/modules/our-cakes/components";
import { useFetch } from "~/shared/hooks";
import { URLS } from "~/shared/urls";
import { ProductsLoader } from "./ProductsLoader";

type SimilarProductsProps = {
  productId: number;
};

type SimilarProductsResponse = {
  similarProducts: ShopProduct[];
};

export function SimilarProducts({ productId }: SimilarProductsProps) {
  const { ref, inView } = useInView({
    triggerOnce: true,
  });
  const { data, load, isLoading } = useFetch<SimilarProductsResponse>(
    URLS.ourCakes.similarProducts(productId),
  );

  useEffect(() => {
    if (inView) {
      load();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productId, inView]);

  if (isLoading) {
    return <ProductsLoader />;
  }

  return (
    <div ref={ref} className="relative">
      {data?.similarProducts && data?.similarProducts.length > 0 ? (
        <ProductsSection
          title={{
            top: trans("similarProducts"),
          }}
          className="bg-white/50"
          classes={{
            container: "gap-6 md:gap-10",
            title: {
              top: "capitalize text-3xl md:text-5xl",
            },
          }}
        >
          <ProductsSlider>
            {data?.similarProducts.map((product) => (
              <SwiperSlide key={product.id} className="h-full w-full">
                <ProductCard product={product} />
              </SwiperSlide>
            ))}
          </ProductsSlider>
        </ProductsSection>
      ) : null}
    </div>
  );
}
